
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.113 1.8c.692 0 1.253.562 1.254 1.254v10.03a1.255 1.255 0 01-1.254 1.254h-8.36A1.255 1.255 0 012.5 13.085V5.562a.409.409 0 01.057-.207.415.415 0 01.065-.089l3.344-3.343a.415.415 0 01.113-.079.416.416 0 01.1-.036.438.438 0 01.083-.008zm-.164 1.053h-5.14v2.008a1.198 1.198 0 01-1.187 1.204H3.645v6.826c0 .222.177.401.395.401h7.909c.218 0 .395-.18.395-.401V3.255a.399.399 0 00-.395-.402zm-1.717 7.724c.23 0 .418.225.418.504 0 .278-.187.503-.418.503H5.635c-.231 0-.418-.225-.418-.503 0-.279.187-.504.418-.504zm0-2.508c.23 0 .418.226.418.504s-.187.504-.418.504H6.888c-.23 0-.417-.226-.417-.504s.187-.504.417-.504z"}})])
          )
        }
      }
    